// extracted by mini-css-extract-plugin
export default {"reason":"social-section-review-ReasonForCrust__reason--UYnUO"};